import { supportedLocales, localeAlternatives } from 'shared-locales';

export default ({ headers, serverConfig, serverState }) => {
  const config = serverConfig
    ? serverConfig
    : serverState && serverState.serverConfig
    ? serverState.serverConfig
    : null;

  const supportedLanguages =
    config && config.supportedLanguages
      ? config.supportedLanguages
      : supportedLocales;

  const initialLanguage =
    config?.defaultInterfaceLanguage ||
    config?.defaultSystemLanguage ||
    'fi-FI';

  let language = supportedLanguages.includes(initialLanguage)
    ? initialLanguage
    : supportedLanguages[0];
  if (serverState && serverState.language) language = serverState.language;

  let cookie = null;
  if (headers && headers.cookie) cookie = headers.cookie;
  if (typeof document !== 'undefined' && document.cookie) {
    cookie = document.cookie;
  }

  const savedLanguage = cookie
    ? cookie.replace(/(?:(?:^|.*;\s*)language\s*=\s*([^;]*).*$)|^.*$/, '$1')
    : null;

  if (savedLanguage && supportedLanguages.includes(savedLanguage)) {
    language = savedLanguage;
  } else {
    if (config && config.defaultInterfaceLanguage) {
      language = config.defaultInterfaceLanguage;
    } else if (headers && headers['accept-language']) {
      // try to get language from accept-language header
      // which could look something like 'en-US,en;q=0.8,fi;q=0.6;en-GB;q=0.4'
      const langOption = headers['accept-language']
        .split(',')
        .map((option) => option.split(';')[0])
        .map((option) =>
          option in localeAlternatives ? localeAlternatives[option] : option
        )
        .find((option) => supportedLanguages.includes(option));
      if (langOption) language = langOption;
    }

    // save language in Cookie
    if (typeof document !== 'undefined') {
      const aYearFromNow = new Date(
        new Date().setFullYear(new Date().getFullYear() + 1)
      );
      document.cookie = `language=${language};path=/;expires=${aYearFromNow}`;
    }
  }

  return language;
};
